// SummaryTable.js
import React, { useState } from "react";
import "./summaryTable.css"; // スタイルを適用するCSSファイルを追加

// const SummaryTable = ({ emptyCount, filledCount }) => {
  const SummaryTable = ({ summaryData }) => { 
    if (!summaryData || typeof summaryData !== "object") {
      return null;
    }
    const summaryArray = Object.values(summaryData);


  return (
    <div className="summary-container">
        <table className="summary-table">
            <thead>
              <tr>
                <th>タイプ</th>
                <th>合計数量</th>
                <th>IP(未入力)</th>
                <th>IP(入力済)</th>
              </tr>
            </thead>
            <tbody>              
                {summaryArray.map((item) => (
                <tr key={item.type}>
                  <td>{item.type}</td>
                  <td>{item.totalCount}</td>
                  <td>{item.emptyCount}</td>
                  <td>{item.filledCount}</td>
                </tr>
              ))}
            </tbody>
        </table>
    </div>
  );
};

export default SummaryTable;